// DonorDash API client
// All requests include credentials (httpOnly cookie) automatically.
// 401 responses clear the session and redirect to login.

function handleUnauthorized() {
  window.dispatchEvent(new CustomEvent('donordash:unauthorized'));
}

async function request(method, path, { params, body } = {}) {
  let url = `/api${path}`;
  if (params) {
    const qs = new URLSearchParams(
      Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
    ).toString();
    if (qs) url += `?${qs}`;
  }

  const res = await fetch(url, {
    method,
    credentials: 'include',
    headers: body ? { 'Content-Type': 'application/json' } : {},
    body: body ? JSON.stringify(body) : undefined,
  });

  if (res.status === 401) {
    handleUnauthorized();
    throw new Error('Unauthorized');
  }

  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText || `HTTP ${res.status}` }));
    throw new Error(err.error || err.message || res.statusText || `HTTP ${res.status}`);
  }

  return res.json();
}

export const api = {
  // Auth
  login: (email, password) => request('POST', '/auth/login', { body: { email, password } }),
  logout: () => request('POST', '/auth/logout'),
  me: () => request('GET', '/auth/me'),

  // Donations
  getDonations: (filters = {}) => request('GET', '/donations', { params: filters }),
  submitDonation: (data) => request('POST', '/donations', { body: data }),
  getMyDonations: () => request('GET', '/donations/mine'),
  sendReceipt: (id) => request('POST', `/donations/${id}/send-receipt`),
  exportUrl: (filters = {}) => {
    const qs = new URLSearchParams(
      Object.entries(filters).filter(([, v]) => v !== undefined && v !== null && v !== '')
    ).toString();
    return `/api/donations/export${qs ? '?' + qs : ''}`;
  },

  // Stats
  getStats: () => request('GET', '/stats'),

  // Donors (admin)
  getDonors: (q) => request('GET', '/donors', q ? { params: { q } } : {}),
  addDonor: (data) => request('POST', '/donors', { body: data }),
  bulkImportDonors: (donors) => request('POST', '/donors/bulk', { body: { donors } }),
  bulkImportDonations: (donations) => request('POST', '/donations/bulk', { body: { donations } }),
  mergeBulkDonors: (groups) => request('POST', '/donors/merge-bulk', { body: { groups } }),
  updateDonor: (id, data) => request('PUT', `/donors/${id}`, { body: data }),
  deleteDonor: (id) => request('DELETE', `/donors/${id}`),

  // Users (admin)
  getUsers: () => request('GET', '/users'),
  addUser: (data) => request('POST', '/users', { body: data }),
  bulkImportUsers: (users) => request('POST', '/users/bulk', { body: { users } }),
  deleteUser: (id) => request('DELETE', `/users/${id}`),
};
